import { render, staticRenderFns } from "./AppSettingOtherList.vue?vue&type=template&id=84544022&scoped=true&"
import script from "./AppSettingOtherList.vue?vue&type=script&lang=js&"
export * from "./AppSettingOtherList.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingOtherList.vue?vue&type=style&index=0&id=84544022&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84544022",
  null
  
)

export default component.exports